import { configureStore } from "@reduxjs/toolkit";
import noteSlice from "./note-slice";
import uiSlice from "./ui-slice";

const store = configureStore({
  reducer: { ui: uiSlice.reducer, note: noteSlice.reducer },
});

export default store;
